export const VALIDATORS_SEGMENT = "validators";

export const VALIDATOR_DETAIL_SEGMENT = "details";

export const VALIDATOR_PERFORMANCE_SEGMENT = "performance";

export const VALIDATOR_RUNS_SEGMENT = "runs";

export const VALIDATORS_PATH = `/admin/${VALIDATORS_SEGMENT}`;

export function validatorDetailPath(name: string): string {
    return `${VALIDATORS_PATH}/${encodeURIComponent(name)}/${VALIDATOR_DETAIL_SEGMENT}`;
}

export function validatorPerformancePath(name: string): string {
    return `${VALIDATORS_PATH}/${encodeURIComponent(name)}/${VALIDATOR_PERFORMANCE_SEGMENT}`;
}

export function validatorRunsPath(name: string): string {
    return `${VALIDATORS_PATH}/${encodeURIComponent(name)}/${VALIDATOR_RUNS_SEGMENT}`;
}
